var Syphon = require('backbone.syphon');
var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var _ = require('underscore');

var tmplConSerBulkLitigationModalView = require('../templates/ConSerBulkLitigationModalView.hbs');
var GridView = require('psa-marionette/views/GridView');
var PageableCollection = require('psa-backbone/models/PageableCollection');
var SubmitBulkComplaintLitigationHoldStatus = require('../services/SubmitBulkComplaintLitigationHoldStatus');

module.exports = Marionette.LayoutView.extend({
  template: tmplConSerBulkLitigationModalView,

  className: 'con-ser-bulk-litigation-modal container-fluid',

  ui: {
    selectedComplaintsContainer: '.selected-complaints-container',
    submit: '.submit',
    form: '.bulk-litigation-form'
  },

  regions: {
    selectedComplaintsContainer: '@ui.selectedComplaintsContainer'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onBeforeShow: function() {
    this.selectedComplaints = new GridView({
      columns: [
        {
          name: 'caseNumber',
          label: 'Case Number',
          cell: 'string',
          width: 11,
          headerCell: 'custom',
          editable: false
        },
        {
          name: 'entityName',
          label: 'Entity Name',
          cell: 'string',
          headerCell: 'custom',
          width: 12,
          editable: false
        },
        {
          name: 'caseManager',
          label: 'Case Manager',
          cell: 'string',
          headerCell: 'custom',
          width: 11,
          editable: false
        },
        {
          name: 'department',
          label: 'Entity Type 1',
          cell: 'string',
          headerCell: 'custom',
          width: 11,
          editable: false
        },
        {
          name: 'status',
          label: 'Status',
          cell: 'string',
          headerCell: 'custom',
          width: 7,
          editable: false
        }
      ],
      collection: new PageableCollection(this.collection.toJSON(), { pageSize: 5 }),
      emptyText: 'No Complaints Selected'
    });
    this.showChildView('selectedComplaintsContainer', this.selectedComplaints);
    this.$('.backgrid.table').addClass('table-bordered');
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.validate().done(function() {
      var l = Ladda.create(self.ui.submit[0]);
      l.start();
      var formData = self.getFormData();
      formData.selectedComplaints = _.map(self.collection.models, function(complaint) {
        return { ComplaintID: complaint.attributes.complaintId };
      });

      formData.newLitigationHoldStatus = self.model.get('litigationHoldStatus') === 'Apply' ? 1 : 0;

      SubmitBulkComplaintLitigationHoldStatus(formData)
        .done(function() {
          self.triggerMethod('modal:close');
          self.options.onRefresh();
        })
        .fail(function() {
          l.stop();
        });
    });
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    return formData;
  },

  validate: function() {
    return this.ui.form.parsley().whenValidate();
  }
});
